import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

const { posSalesByProduct: { getPosSalesByProduct } } = apiUrls;

export const POS_SALES_BY_PRODUCT_SUCCESS = 'POS_SALES_BY_PRODUCT_SUCCESS';
export const POS_SALES_BY_PRODUCT_LOADING = 'POS_SALES_BY_PRODUCT_LOADING';


export const getPosSalesByProductData = () => async (dispatch) => {
        try {
            const { url } = getPosSalesByProduct
            const requestData = {
                ...getPosSalesByProduct, url: getPosSalesByProduct.url,                
            };
            const data = await REQUEST(requestData);
            dispatch({
                type: POS_SALES_BY_PRODUCT_SUCCESS,
                data,
            })
        } catch (e) {

            dispatch({
                type: POS_SALES_BY_PRODUCT_SUCCESS,
                data: {
                    code: "",
                    modal: null,
                    notifications: null,
                    paginationInfo: null
                },
            })
        }

    }



export const handleLoader = isLoading => (dispatch) => {    
    dispatch({
        type: POS_SALES_BY_PRODUCT_LOADING,
        isLoading,
    })
}
